import React, { useCallback, useState } from 'react';
import InputField, { InputFieldProps } from '../InputField';
import s from './LimitedTextInputField.scss';

export interface Props extends Omit<InputFieldProps, 'postfix' | 'type'> {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  maxLength: number;
}

/** One of our standard `<input type="text" />`s.
 *
 * Limits input to a specified length (`max`) and displays the remaining character allowance to the right of the inner input.
 */
const LimitedTextInputField = React.forwardRef<HTMLInputElement, Props>(
  ({ maxLength, value, defaultValue, onChange, ...rest }, ref) => {
    const [valueLength, setValueLength] = useState(
      `${value ?? defaultValue ?? ''}`.length
    );
    const handleOnChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length > maxLength) {
          return;
        }
        setValueLength(e.target.value.length);
        onChange && onChange(e);
      },
      [onChange, maxLength]
    );

    return (
      <InputField
        type="text"
        maxLength={maxLength}
        value={value}
        defaultValue={defaultValue}
        onChange={handleOnChange}
        postfix={
          <span className={s['postfix']}>{maxLength - (0 | valueLength)}</span>
        }
        {...rest}
        ref={ref}
      />
    );
  }
);

export default LimitedTextInputField;
